<template>
  <div>
    <h1>Déclarations Hors Référencement</h1>
    <div class="d-flex justify-content-between align-items-start">
      <SubstituteAdh :members="saisieScreen ? [this.selectedMember] : members" :selectedMemberGuid="selectedMemberGuid" @update="selectedMemberGuid = $event; onlyCdm = false"></SubstituteAdh>
      <a v-if="selectedMember && saisieScreen" href="/static/Documentation adherent saisie.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
      <a v-else href="/static/Documentation adherent resultats.pdf" target="_blank" class="btn btn-warning">Mode d'emploi</a>
    </div>
    <label v-if="selectedMember && selectedMember.Level == 3">
      <input
             type="checkbox"
             :checked="selectedMember && socSaisieGuidList.indexOf(selectedMember.Guid) !== -1"
             @click="toggleSaisieSoc" />
      Saisie à la société
    </label>
    <div class="d-flex justify-content-between align-items-center">
      <div class="buttons-container">
        <button @click="modalOpen=true">Créer un nouveau fournisseur</button>
        <br />
        <div v-if="selectedMember && saisieScreen">
          <button v-if="!saisieEnded" @click="endSaisie">Terminer la saisie</button>
          <span v-else>La saisie est terminée</span>
        </div>
      </div>
      <button class="btn btn-success" @click="exportDatas">Exporter les données</button>
    </div>
    <small v-if="saisieScreen">NB : Pour créer/modifier une déclaration vous devez au moins renseigner un CA >= 50 000€</small>
    <vue-good-table v-if="$store.state.loader == 0"
                    :columns="columns"
                    :rows="rows"
                    :sort-options="{enabled: true, initialSortBy: {field: 'CA', type: 'desc'}}"
                    :group-options="{enabled: true}">
      <template slot="table-row" slot-scope="props">
        <span v-if="!saisieEnded && selectedMember && saisieScreen && props.column.field == 'CA'">
          <input class="form-control" type="number" :placeholder="props.row[props.column.field]" v-model="models[props.row.IdFrsHR].CA" @change="changedDeclaration(props.row.IdFrsHR)" />
        </span>
        <span v-else-if="!saisieEnded && selectedMember && saisieScreen && props.column.field == 'RFA'">
          <input class="form-control" type="number" :placeholder="props.row[props.column.field]" v-model="models[props.row.IdFrsHR].RFA" @change="changedDeclaration(props.row.IdFrsHR)" />
        </span>
        <span v-else-if="props.column.field == 'HasContract'">
          <input type="checkbox" disabled v-if="saisieEnded || !selectedMember || !saisieScreen" :checked="props.row.HasContract" />
          <input type="checkbox" v-else v-model="models[props.row.IdFrsHR].HasContract" @change="changedDeclaration(props.row.IdFrsHR)" />
        </span>
        <span v-else-if="!saisieEnded && selectedMember && saisieScreen && props.column.field == 'NbPdv'">
          <input class="form-control" type="number" :placeholder="props.row[props.column.field]" v-model="models[props.row.IdFrsHR].NbPdv" @change="changedDeclaration(props.row.IdFrsHR)" />
        </span>
        <span v-else-if="!saisieEnded && selectedMember && saisieScreen && props.column.field == 'Commentaire'">
          <input class="form-control" type="text" :placeholder="props.row[props.column.field]" v-model="models[props.row.IdFrsHR].Commentaire" @change="changedDeclaration(props.row.IdFrsHR)" />
        </span>
        <span v-else-if="props.column.field == 'Changed'" class="d-flex">
          <button class="btn btn-success" v-if="!saisieEnded && selectedMember && saisieScreen && props.row[props.column.field]" @click="updateDeclaration(props.row.IdFrsHR)"><font-awesome-icon icon="check"></font-awesome-icon></button>
          <button class="btn btn-danger" v-if="!saisieEnded && selectedMember && saisieScreen && props.row.CA" @click="deleteDeclaration(props.row.IdFrsHR)"><font-awesome-icon icon="trash"></font-awesome-icon></button>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
    <CreateFrsHRModal v-if="modalOpen"
                      :open="modalOpen"
                      @close="modalOpen=false"
                      @submitted="modalOpen=false;getDeclarations()"
                      :familles="families"
                      :sousFamilles="subFamilies"></CreateFrsHRModal>
  </div>
</template>

<script>
  import SubstituteAdh from "@/components/SubstituteAdh";
  import CreateFrsHRModal from "@/components/CreateFrsHRModal";

  import { getNomenclatureByLevel } from "@/utils/frs"
  import { getAllMembersHierarchy, getSocSaisieHR, toggleSocSaisieHR } from "@/utils/member";
  import {
    getAllDeclarations,
    updateDeclaration as updateDeclarationHR,
    endSaisie as endSaisieHR,
    isSaisieEnded as isSaisieHREnded
  } from "@/utils/frsHR";
  import { exportExcel } from "@/utils/exportExcel";

  export default {
    name: "FrsHR",
    components: {
      SubstituteAdh,
      CreateFrsHRModal
    },
    data() {
      return {
        members: [],
        selectedMemberGuid: "",
        declarations: [],
        models: {},
        saisieEnded: true,
        modalOpen: false,
        families: [],
        subFamilies: [],
        socSaisieGuidList: []
      }
    },
    mounted() {
      getSocSaisieHR().then(_res => {
        this.socSaisieGuidList = _res
        getAllMembersHierarchy(-1, true).then(res => {
          this.members = res;
        })
        getNomenclatureByLevel(1).then(res => this.families = res)
        getNomenclatureByLevel(2).then(res => this.subFamilies = res)
      });
    },
    watch: {
      selectedMember() {
        if (this.selectedMember) {
          this.models = {};
          this.getDeclarations();
          if (this.saisieScreen) {
            isSaisieHREnded(this.selectedMember.Guid).then(res => this.saisieEnded = res);
          }
        }
      },
    },
    computed: {
      me() {
        let minLevel = this.members.reduce((acc, el) => el.Level < acc ? el.Level : acc, 5)
        if (this.$store.state.self.isAdmin && minLevel === 1 && this.members.filter(el => el.Level === minLevel).length > 1) {
          minLevel = 0; // CMEM
        }
        return this.members.find(el => el.Level === minLevel) || ({ Name: "Admin", Level: 0, Label: "[A] Admin", Guid: "00000000-0000-0000-0000-000000000000" });
      },
      selectedMember() {
        if (!this.selectedMemberGuid) return this.me
        return this.members.find(el => el.Guid === this.selectedMemberGuid) || this.me
      },
      saisieScreen() {
        return this.selectedMember.Level == 4 || (this.selectedMember.Level == 3 && this.socSaisieGuidList.indexOf(this.selectedMember.Guid) !== -1)
      },
      rows() {
        return [{
          SousGroupeName: "Totaux",
          children: this.declarations
        }]
      },
      columns() {
        let res = [
          { label: "Sous Groupe", field: "SousGroupeName", filterOptions: { enabled: true, } },
          { label: "Société", field: "SocName", filterOptions: { enabled: true, } },
          { label: "Point de vente", field: "PdvLabel", filterOptions: { enabled: true } },
          { label: "Fournisseur", field: "NomFrsHR", filterOptions: { enabled: true } },
          { label: "Famille", field: "FamilleFrsHR", filterOptions: { enabled: true } },
          { label: "Sous Famille", field: "SousFamilleFrsHR", filterOptions: { enabled: true } },
          { label: "CA", field: "CA", type: "number", formatFn: this.formatNbEur, headerField: this.generateSumBy("CA"), tooltip: (this.saisieScreen ? "Le CA doit être renseigné et supérieur ou égal à 50 000€" : "") },
          { label: "RFA", field: "RFA", type: "number", formatFn: this.formatNbEur, headerField: this.generateSumBy("RFA") },
          { label: "Contrat ?", field: "HasContract", type: "boolean" },
          //{ label: "Nombre de PdV ?", field: "NbPdv", type: "number", formatFn: this.formatNbEur, headerField: this.generateSumBy("NbPdv") },
          { label: "Commentaire", field: "Commentaire" },
          { label: "", field: "Changed", sortable: false },
        ]
        if (this.selectedMember && this.saisieScreen) return res.slice(3);
        return res.slice(0, res.length - 1);
      },
    },
    methods: {
      getDeclarations() {
        getAllDeclarations(this.selectedMember.Guid).then(res => {
          this.declarations = res.map(row => {
            if (!this.models[row.IdFrsHR]) { // On rempli les modèles des inputs
              this.models[row.IdFrsHR] = {
                CA: row.CA,
                RFA: row.RFA,
                HasContract: row.HasContract,
                NbPdv: row.NbPdv,
                Commentaire: row.Commentaire
              }
            }
            let Changed = row.CA != this.models[row.IdFrsHR].CA ||
              row.RFA != this.models[row.IdFrsHR].RFA ||
              row.HasContract != this.models[row.IdFrsHR].HasContract ||
              row.NbPdv != this.models[row.IdFrsHR].NbPdv ||
              row.Commentaire != this.models[row.IdFrsHR].Commentaire

            let pdvMember = this.members.find(el => el.Level == 4 && el.Guid == row.PdvGuid)
            if (!pdvMember) return { ...row, Changed };
            return {
              ...row,
              PdvLabel: pdvMember.Label,
              PdvName: pdvMember.Name,
              SocName: pdvMember.SocieteName,
              SousGroupeName: pdvMember.SousGroupeName,
              Changed
            }
          })
        })
      },
      toggleSaisieSoc(e) {
        e.preventDefault();
        if (!this.selectedMember || this.selectedMember.Level != 3) return;
        const validation = window.confirm("Les données saisies au point de vente seront supprimées. Voulez vous continuer ?");
        if (!validation) return;

        toggleSocSaisieHR(this.selectedMember.Guid).then(() => {
          this.models = {};
          getSocSaisieHR().then(_res => {
            this.socSaisieGuidList = _res;
            this.getDeclarations();
            if (this.saisieScreen) {
              isSaisieHREnded(this.selectedMember.Guid).then(res => this.saisieEnded = res);
            }
          });
        })
      },
      changedDeclaration(idFrsHR) {
        let _declarations = this.declarations.slice();
        let row = this.declarations.find(el => el.IdFrsHR == idFrsHR)
        if (!row) return;

        // Y a-t-il eu un changement ?
        let newChanged = row.CA != this.models[row.IdFrsHR].CA ||
          row.RFA != this.models[row.IdFrsHR].RFA ||
          row.HasContract != this.models[row.IdFrsHR].HasContract ||
          row.NbPdv != this.models[row.IdFrsHR].NbPdv ||
          row.Commentaire != this.models[row.IdFrsHR].Commentaire

        if (newChanged != row.Changed) { // si oui et qu'il n'y avait pas de changement avant, ou inversement
          row.Changed = newChanged
          this.declarations = _declarations;
        }
      },
      updateDeclaration(idFrsHR) {
        if (!this.selectedMember) return;
        let CA = this.models[idFrsHR].CA || 0;
        let RFA = this.models[idFrsHR].RFA || 0;
        let HasContract = this.models[idFrsHR].HasContract || false;
        let NbPdv = this.models[idFrsHR].NbPdv || 0;
        let Commentaire = this.models[idFrsHR].Commentaire || "";
        if (!CA || CA == 0 || CA < 50000) {
          window.alert("Vous devez au moins renseigner un CA >= 50 000€");
          return;
        }
        updateDeclarationHR(this.selectedMember.Guid, idFrsHR, CA, RFA, HasContract, NbPdv, Commentaire).then(res => {
          if (res == "OK") {
            this.models[idFrsHR] = undefined;
            this.getDeclarations();
          }
        });
      },
      deleteDeclaration(idFrsHR) {
        const validation = window.confirm("Voulez-vous vraiment supprimer cette déclaration ?")
        if (validation) {
          updateDeclarationHR(this.selectedMember.Guid, idFrsHR, 0, 0, false, 0, "").then(res => {
            if (res == "OK") {
              this.models[idFrsHR] = undefined;
              this.getDeclarations();
            }
          });
        }
      },
      endSaisie() {
        if (this.selectedMember && this.saisieScreen) {
          const validation = window.confirm("Voulez-vous vraiment terminer la saisie ?")
          if (validation) {
            endSaisieHR(this.selectedMember.Guid).then(() => {
              this.getDeclarations();
              isSaisieHREnded(this.selectedMember.Guid).then(res => this.saisieEnded = res);
            })
          }
        }
      },
      generateSumBy(field) {
        return function (rowObj) {
          return rowObj.children.reduce((acc, el) => ((el && el[field]) ? (el[field] + acc) : acc), 0);
        }
      },
      formatNbEur(n) {
        return n.toLocaleString("fr-FR", { maximumFractionDigits: 0 });
      },
      formatNbPercent(n) {
        n = n / 100;
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
      exportDatas() {
        exportExcel(this.columns, this.rows[0].children, "Déclarations Hors Référencement " + this.selectedMember.Name)
      }
    }
  }
</script>

<style scoped>
  .buttons-container {
      display: flex;
      margin-top: 28px;
      margin-bottom: 12px;
      column-gap: 12px;
  }

  .mode-emploi {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/DeclarationHR.vue